import type { QueryRoute } from './api/queryApi'

/**
 * Build-time defaults. Anything the user changes in Settings is persisted to
 * localStorage and takes precedence over these.
 */

function readString(value: unknown, fallback: string): string {
  return typeof value === 'string' && value.trim() ? value.trim() : fallback
}

const rawRoute = import.meta.env.VITE_DEFAULT_QUERY_ROUTE

export const env = {
  /**
   * `/api` routes through the Vite dev proxy (see vite.config.ts). Point this
   * at the backend origin for a static production build.
   */
  apiBaseUrl: readString(import.meta.env.VITE_API_BASE_URL, '/api'),

  defaultRoute: (rawRoute === 'production' ? 'production' : 'test') as QueryRoute,

  isDev: import.meta.env.DEV,
} as const
